module.exports = __webpack_public_path__ + "img/sunjing.216b1337.png";